export default function isNullOrUndefined(
    value: unknown
): value is undefined | null {
    return (
        value === undefined ||
        value === null ||
        (typeof value === 'number' && isNaN(value))
    );
}
